import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    hasError?: boolean;
    type: "radio";
}

const FormRadioButtonDefault: React.FC<IProps> = (props) => {

    const { hasError, type, ...InputProps } = props;

    return (<input {...InputProps} type={type}/>)

};

const FormRadioButton = styled(FormRadioButtonDefault)`
`;

export default FormRadioButton;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/form/form_radio_button.tsx